import { useLocation, Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

export default function NotFound() {
  const location = useLocation();

  return (
    <>
      <Navbar />
      <div className="relative flex flex-col items-center justify-center min-h-[80vh] text-center px-4 pt-16">
        <h1 className="absolute bottom-1/4 text-9xl md:text-[12rem] font-black text-foreground-50 select-none pointer-events-none z-0">
          404
        </h1>
        <div className="relative z-10">
          <h1 className="text-xl md:text-2xl font-heading font-semibold text-foreground-900 mt-6">页面未找到</h1>
          <p className="mt-2 text-sm text-foreground-500 font-mono">{location.pathname}</p>
          <p className="mt-4 text-sm text-foreground-600">抱歉，您访问的页面不存在</p>
          <Link
            to="/"
            className="inline-block mt-6 px-5 py-2 bg-primary-500 hover:bg-primary-600 text-white rounded-full text-sm font-label transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            返回首页
          </Link>
        </div>
      </div>
      <Footer />
    </>
  );
}